import { createClient } from "@nexys/user-management-client";

/**
 * The one UM client for this app — everyone (AuthProvider, kit
 * components, page-level call sites) shares this single instance so
 * the cookie jar + onUnauthorized handler are consistent.
 *
 * Same-origin in production (the SPA is served by the API server)
 * and proxied in dev (see vite.config.ts).
 */
// Routes an anonymous visitor may legitimately sit on — the initial
// /api/me probe 401s there and must NOT bounce them to /sign-in.
// /accept-invitation is included so RequireAuth's soft redirect (which
// preserves the return path) handles it instead of a hard reload.
const PUBLIC_PREFIXES = [
  "/sign-in",
  "/sign-up",
  "/forgot-password",
  "/reset-password",
  "/accept-invitation",
  "/auth/",
];

export const um = createClient({
  baseUrl: window.location.origin,
  onUnauthorized: () => {
    // Drop the user on /sign-in if the server rejects the session.
    // Skip when we're already on an auth route or this loops.
    const p = window.location.pathname;
    if (!PUBLIC_PREFIXES.some((prefix) => p.startsWith(prefix))) {
      window.location.assign("/sign-in");
    }
  },
});
